import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { setSession, switchTenant } from '@darice/auth-client';
import { DEFAULT_RETURN_TO, resolveReturnTo } from '../lib/returnTo';

// Tenant switching per design §3.14: /switch?tenantId=... re-issues the
// session JWT with the new activeTenantId (updating the darice-session domain
// cookie via setSession) and redirects back to the validated return_to target.
export default function SwitchTenant() {
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tenantId = params.get('tenantId');
    if (!tenantId) {
      setError('FAIL: /switch requires a tenantId query parameter');
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await switchTenant(tenantId);
        if (!res.success || !res.sessionJwt || res.expiresAt == null) {
          if (!cancelled) setError(res.error ?? 'SWITCH_FAILED');
          return;
        }
        setSession(res.sessionJwt, res.expiresAt);
        window.location.assign(resolveReturnTo(params.get('return_to')) ?? DEFAULT_RETURN_TO);
      } catch (e) {
        if (!cancelled) setError((e as Error).message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [location.search]);

  if (error) {
    return (
      <main>
        <p className="auth-error" data-testid="switch-error" role="alert">{error}</p>
      </main>
    );
  }
  return (
    <main>
      <p>Switching workspace...</p>
    </main>
  );
}
